<template>
  <div data-testid="exchange-form-wallet" class="exchange-form-wallet">
    <div data-testid="fiat-balance">
      <span
        class="exchange-form-wallet__crypto-balance"
        @click="onClickCryptoBalance"
      >{{ props.wallet.formattedCryptoBalance }}</span>
      ({{ fiatBalance }})
    </div>
    <div data-testid="shrunken-primary-address">{{ props.wallet.shrunkenPrimaryAddress }}</div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from "vue";
import { formatNumberWithDecimals } from "@/helpers/numberFormatter";
import { WalletOptionModel } from "@/models";
import { getMinimumLimitForCurrency } from "@/helpers/minimumLimitForCurrencyHelper";
import Decimal from "decimal.js";

const emit = defineEmits<{
  (event: "clickCryptoBalance", value: string): void;
}>();

const props = defineProps<{
  wallet: WalletOptionModel
}>();
const fiatBalance = computed(() => `~${formatNumberWithDecimals(props.wallet.fiatBalance.amount, 2)} ${props.wallet.fiatBalance.currency}`);

function onClickCryptoBalance() {
  const minimumLimit = getMinimumLimitForCurrency(props.wallet.balance.currency);
  const value = new Decimal(props.wallet.balance.amount).minus(minimumLimit);
  if (value.toNumber() < 0) return;

  const decimalPlaces = props.wallet.balance.amount.split(".")[1]?.length || 0;
  emit("clickCryptoBalance", value.toFixed(decimalPlaces));
}
</script>

<style lang="scss" scoped>
@import "@scss-vars";

.exchange-form-wallet {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  text-align: right;
  font-size: rem(11);
  color: $black-40;

  [dir="rtl"] & {
    text-align: left;
  }

  &__crypto-balance {
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      text-decoration: none;
    }
  }
}
</style>
